export default "__VITE_ASSET__DekTzcKj__"